import React from 'react';
import PropTypes from 'prop-types';
import { Button, Field } from './UIComponents';

const styles = {
  addButton: {
    background: 'none',
    border: 'none',
    borderRadius: '4px',
    color: '#6c757d',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: '20px',
    height: '24px',
    justifyContent: 'center',
    padding: '4px',
    transition: 'all 0.2s ease',
    width: '24px'
  },
  backButton: {
    background: '#f5f5f5',
    border: '1px solid #ccc',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    padding: '8px 16px'
  },
  carrierItem: {
    alignItems: 'center',
    borderBottom: '1px solid #f0f0f0',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 0'
  },
  carrierName: {
    color: '#333',
    fontSize: '14px',
    fontWeight: '500'
  },
  carriersList: {
    borderTop: '1px solid #e7e6e6',
    flex: 1,
    marginTop: '16px',
    maxHeight: '200px',
    overflowY: 'auto',
    paddingRight: '8px',
    scrollbarColor: '#c1c1c1 transparent',
    scrollbarWidth: 'thin'
  },
  clearButton: {
    alignItems: 'center',
    background: 'none',
    border: 'none',
    color: '#6c757d',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '14px',
    gap: '4px'
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#6c757d',
    padding: '4px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    transition: 'all 0.2s ease'
  },
  content: {
    color: '#333',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    lineHeight: '1.6',
    overflow: 'hidden'
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '85vh',
    maxWidth: '600px',
    overflowY: 'auto',
    padding: '24px',
    position: 'relative',
    width: '90%'
  },
  modalHeader: {
    alignItems: 'center',
    borderBottom: '1px solid #e7e6e6',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
    paddingBottom: '12px'
  },
  modalTitle: {
    color: '#333',
    fontSize: '18px',
    fontWeight: '600',
    margin: 0
  },
  modalContent: {
    color: '#333',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    lineHeight: '1.6'
  },
  modalFooter: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
    marginTop: '20px'
  },
  nextButton: {
    background: '#1976d2',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '16px',
    padding: '8px 16px'
  },
  overlay: {
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 1000
  },
  removeCarrierButton: {
    alignItems: 'center',
    background: 'none',
    border: 'none',
    color: '#1976d2',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '16px',
    height: '18px',
    justifyContent: 'center',
    padding: '0',
    width: '18px'
  },
  searchContainer: {
    alignItems: 'center',
    display: 'flex',
    gap: '12px',
    justifyContent: 'space-between',
    marginBottom: '20px',
    marginTop: '20px'
  },
  searchInput: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#333',
    flex: 1,
    fontSize: '14px',
    outline: 'none'
  },
  searchInputContainer: {
    alignItems: 'center',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px',
    display: 'flex',
    flex: 1,
    gap: '8px',
    padding: '12px',
    position: 'relative'
  },
  selectedCarrier: {
    alignItems: 'center',
    backgroundColor: '#e3f2fd',
    borderRadius: '20px',
    color: '#1976d2',
    display: 'inline-flex',
    fontSize: '14px',
    fontWeight: '500',
    gap: '8px',
    marginBottom: '8px',
    marginRight: '8px',
    padding: '8px 12px'
  },
  selectedCarriersContainer: {
    marginBottom: '20px'
  },
  healthConditionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(180px, 1fr))',
    gap: '8px',
    marginTop: '8px',
    marginBottom: '8px'
  }
};

const HealthAnalyzerDetailModal = ({ onClose, data }) => {
  const handleBack = () => {
    if (onClose) onClose();
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={styles.modalHeader}>
            <h2 style={styles.modalTitle}>Health Analyzer - Result Details</h2>
            <Button variant='secondary' onClick={onClose} style={{ fontSize: 24, width: 32, height: 32, borderRadius: 4, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              ×
            </Button>
          </div>
          <div style={{ ...styles.modalContent, padding: '8px 0 0 0' }}>
            <div
              style={{
                background: '#f7fafd',
                borderRadius: 8,
                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                padding: '20px 24px',
                marginBottom: 16,
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '18px',
                alignItems: 'center'
              }}
            >
              <div>
                <Field label='Carrier'>
                  <span style={{ fontWeight: 600, color: '#1976d2', fontSize: 16 }}>{data.carrier}</span>
                </Field>
                <Field label='Underwriting Class'>
                  <span style={{ fontWeight: 500, color: '#2a3b4d', fontSize: 15 }}>{data.underwritingClass}</span>
                </Field>
                <Field label='Tobacco Status'>
                  <span
                    style={{
                      background: data.tobaccoStatus ? '#ffe0b2' : '#e0e7ef',
                      color: data.tobaccoStatus ? '#a65c00' : '#3a4d63',
                      borderRadius: 4,
                      padding: '2px 8px',
                      fontWeight: 500,
                      fontSize: 13
                    }}
                  >
                    {data.tobaccoStatus || 'Non-Tobacco'}
                  </span>
                </Field>
                <Field label='Table Rating'>
                  <span style={{ fontWeight: 500, color: '#7c4dff', fontSize: 14 }}>{data.tableRating || 'N/A'}</span>
                </Field>
              </div>
              <div>
                <Field label='Reasoning'>
                  <span style={{ color: '#444', fontStyle: 'italic', fontSize: 14 }}>{data.reasoning || 'No specific reasoning provided.'}</span>
                </Field>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '24px', marginBottom: 8 }}>
              <div style={{ flex: 1 }}>
                <Field label='Credits'>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {Array.isArray(data.credits) && data.credits.length > 0 ? (
                      data.credits.map((credit, idx) => (
                        <span
                          key={idx}
                          style={{
                            background: '#e3f9e5',
                            color: '#388e3c',
                            borderRadius: 12,
                            padding: '4px 12px',
                            fontSize: 13,
                            fontWeight: 500,
                            marginBottom: 4
                          }}
                        >
                          {credit}
                        </span>
                      ))
                    ) : (
                      <span style={{ color: '#888', fontSize: 13 }}>No credits reported.</span>
                    )}
                  </div>
                </Field>
              </div>
              <div style={{ flex: 1 }}>
                <Field label='Debits'>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {Array.isArray(data.debits) && data.debits.length > 0 ? (
                      data.debits.map((debit, idx) => (
                        <span
                          key={idx}
                          style={{
                            background: '#ffe3e3',
                            color: '#d32f2f',
                            borderRadius: 12,
                            padding: '4px 12px',
                            fontSize: 13,
                            fontWeight: 500,
                            marginBottom: 4
                          }}
                        >
                          {debit}
                        </span>
                      ))
                    ) : (
                      <span style={{ color: '#888', fontSize: 13 }}>No debits reported.</span>
                    )}
                  </div>
                </Field>
              </div>
            </div>
          </div>
          <div style={styles.modalFooter}>
            <Button onClick={handleBack} variant='secondary' type='button'>
              Back
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

HealthAnalyzerDetailModal.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default HealthAnalyzerDetailModal;
